import Api from './Api';
import Configuracao from '../util/Configuracao';
import { parse } from 'date-fns';

class PrestadorApi extends Api {
  async consultarBairros () {
    try {
      const bairrosUrl = Configuracao.getConfiguracao().urlBairrosPrestadoresConsultar;
      const response = await this.fetch(bairrosUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarNomes () {
    try {
      const nomesUrl = Configuracao.getConfiguracao().urlNomesPrestadoresConsultar;
      const response = await this.fetch(nomesUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarNomesTodosPrestadores () {
    try {
      const nomesUrl = Configuracao.getConfiguracao().urlConsultarNomesTodosPrestadores;
      const response = await this.fetch(nomesUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarNomesTodosPrestadoresCredenciados () {
    try {
      const nomesUrl = Configuracao.getConfiguracao().urlConsultarNomesTodosPrestadoresCredenciados;
      const response = await this.fetch(nomesUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarEspecialidades () {
    try {
      const especialidadesUrl = Configuracao.getConfiguracao().urlEspecialidadesPrestadoresConsultar;
      const response = await this.fetch(especialidadesUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarNomesTodosGrupos () {
    try {
      const nomesUrl = Configuracao.getConfiguracao().urlConsultarNomesTodosGrupos;
      const response = await this.fetch(nomesUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarNomesGruposPorTipo (tipoGrupo) {
    try {
      const urlConsultarNomesGruposPorTipo = Configuracao.getConfiguracao().urlConsultarNomesGruposPorTipo + tipoGrupo;
      const response = await this.fetch(urlConsultarNomesGruposPorTipo);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarGruposPrestadores (nomeGrupo) {
    try {
      const urlGruposPrestadores = Configuracao.getConfiguracao().urlGruposPrestadores + nomeGrupo + '/tipo/T';
      const response = await this.fetch(urlGruposPrestadores);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirGrupos (grupos) {
    try {
      const excluirGrupoUrl = Configuracao.getConfiguracao().urlExcluirGrupo;
      await this.fetch(excluirGrupoUrl, 'put', grupos);
    } catch (error) {
      console.error(error);
    }
  }

  async incluirGrupo (grupo) {
    try {
      const incluirGrupoUrl = Configuracao.getConfiguracao().urlIncluirGrupo;
      const response = await this.fetch(incluirGrupoUrl, 'put', grupo); // , {'content-type': 'application/json'});
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async alterarGrupo (grupo) {
    try {
      const alterarGrupoUrl = Configuracao.getConfiguracao().urlAlterarGrupo;
      const response = await this.fetch(alterarGrupoUrl, 'put', grupo); // , {'content-type': 'application/json'});
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarPrestadoresVinculados (codGrupo, indGrupoOdontologico) {
    try {
      const urlPrestadoresVinculados = Configuracao.getConfiguracao().urlPrestadoresVinculados + codGrupo + '/grupo_odontologico/' + indGrupoOdontologico;
      const response = await this.fetch(urlPrestadoresVinculados);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarPrestadoresDesvinculados (codGrupo) {
    try {
      const urlPrestadoresDesvinculados = Configuracao.getConfiguracao().urlPrestadoresDesvinculados + codGrupo;
      const response = await this.fetch(urlPrestadoresDesvinculados);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async vincularPrestadoresEmLote (grupo) {
    try {
      const urlVincularPrestadoresEmLote = Configuracao.getConfiguracao().urlVincularPrestadoresEmLote;
      const result = this.fetch(urlVincularPrestadoresEmLote, 'PUT', grupo, { 'content-type': 'application/json' });
      return result;
    } catch (error) {
      console.error(error);
    }
  }
  async desvincularPrestadoresEmLote (grupo) {
    try {
      const urlDesvincularPrestadoresEmLote = Configuracao.getConfiguracao().urlDesvincularPrestadoresEmLote;
      const result = this.fetch(urlDesvincularPrestadoresEmLote, 'PUT', grupo, { 'content-type': 'application/json' });
      return result;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarPrestador (CPF_CNPJ, nome) {
    try {
      const urlPrestador = Configuracao.getConfiguracao().urlPrestador + CPF_CNPJ + '/nome/' + nome;
      const response = await this.fetch(urlPrestador);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarPrestadoresSemOrgaoExterno () {
    try {
      const urlPrestadorSemOrgaoExterno = Configuracao.getConfiguracao().urlPrestadorSemOrgaoExterno;
      const response = await this.fetch(urlPrestadorSemOrgaoExterno);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }  
  async incluirPrestador (prestador) {
    try {
      const urlIncluirPrestador = Configuracao.getConfiguracao().urlIncluirPrestador;
      const response = await this.fetch(urlIncluirPrestador, 'put', prestador);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async alterarPrestador (prestador) {
    try {
      const urlAlterarPrestador = Configuracao.getConfiguracao().urlAlterarPrestador;
      const response = await this.fetch(urlAlterarPrestador, 'put', prestador);
      return response;
    } catch (error) {
      console.error(error);
    }
  }  
  async vincularPrestadorOrgaoExterno (codPrestador, nomPrestador) {
    try {
      const urlVincularPrestadorOrgaoExterno = Configuracao.getConfiguracao().urlVincularPrestadorOrgaoExterno + codPrestador + '/' + nomPrestador;
      const response = await this.fetch(urlVincularPrestadorOrgaoExterno, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirPrestadoresEmLote (prestadores) {
    try {
      const urlExcluirPrestadores = Configuracao.getConfiguracao().urlExcluirPrestadores;
      const result = await this.fetch(urlExcluirPrestadores, 'post', prestadores);
      return result;
    } catch (error) {
      console.error(error);
      return error;
    }
  }

  async consultarEnderecos (codPrestador) {
    try {
      const urlEnderecosPrestador = Configuracao.getConfiguracao().urlEnderecosPrestador + codPrestador;
      const response = await this.fetch(urlEnderecosPrestador);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async incluirEndereco (endereco) {
    try {
      const urlIncluirEndereco = Configuracao.getConfiguracao().urlIncluirEndereco;
      const result = await this.fetch(urlIncluirEndereco, 'put', endereco);
      return result;
    } catch (error) {
      console.error(error);
    }
  }
  async alterarEndereco (endereco) {
    try {
      const urlAlterarEndereco = Configuracao.getConfiguracao().urlAlterarEndereco;
      const result = await this.fetch(urlAlterarEndereco, 'put', endereco);
      return result;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirEnderecosEmLote (enderecos) {
    try {
      const urlExcluirEnderecos = Configuracao.getConfiguracao().urlExcluirEnderecos;
      const result = await this.fetch(urlExcluirEnderecos, 'post', enderecos);
      return result;
    } catch (error) {
      console.error(error);
      return error;
    }
  }
  async consultarEspecialidadesDoPrestador (codPrestador) {
    try {
      const urlConsultarEspecialidadesDoPrestador = Configuracao.getConfiguracao().urlConsultarEspecialidadesDoPrestador + codPrestador;
      const response = await this.fetch(urlConsultarEspecialidadesDoPrestador);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarEspecialidadesNaoVinculadas (codPrestador) {
    try {
      const urlConsultarEspecialidadesNaoVinculadasAoPrestador = Configuracao.getConfiguracao().urlConsultarEspecialidadesNaoVinculadasAoPrestador + codPrestador;
      const response = await this.fetch(urlConsultarEspecialidadesNaoVinculadasAoPrestador);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async vincularEspecialidades (codPrestador, especialidades) {
    try {
      const urlVincularEspecialidades = Configuracao.getConfiguracao().urlVincularEspecialidades + codPrestador;
      await this.fetch(urlVincularEspecialidades, 'put', especialidades);
    } catch (error) {
      console.error(error);
    }
  }
  async desvincularEspecialidades (codPrestador, especialidades) {
    try {
      const urlDesincularEspecialidades = Configuracao.getConfiguracao().urlDesincularEspecialidades + codPrestador;
      await this.fetch(urlDesincularEspecialidades, 'put', especialidades);
    } catch (error) {
      console.error(error);
    }
  }
  async consultarCredenciamentos (codPrestador) {
    try {
      const urlConsultarPrestadorCredenciamento = Configuracao.getConfiguracao().urlConsultarPrestadorCredenciamento + codPrestador;
      const response = await this.fetch(urlConsultarPrestadorCredenciamento);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async salvarDataInicial (filter, data) {
    try {
      const salvarDataInicialPrestadorUrl = Configuracao.getConfiguracao().salvarDataInicialPrestadorUrl + filter.codCredenciamento + '/data/' + parse(data);
      await this.fetch(salvarDataInicialPrestadorUrl, 'put');
      return 'Data alterada com sucesso.';
    } catch (error) {
      console.error(error);
      return 'Não foi possível realizar a alteração da data. Favor tentar novamente.';
    }
  }
  async salvarDataFim (filter, data) {
    try {
      const salvarDataFimPrestadorUrl = Configuracao.getConfiguracao().salvarDataFimPrestadorUrl + filter.codCredenciamento + '/data/' + parse(data);
      await this.fetch(salvarDataFimPrestadorUrl, 'put');
      return 'Data final atualizada com sucesso.';
    } catch (error) {
      console.error(error);
      return 'Não foi possível realizar a alteração da data. Favor tentar novamente.';
    }
  }
  async excluirCredenciamentosEmLote (credenciamentos) {
    try {
      const urlExcluirCredenciamentos = Configuracao.getConfiguracao().urlExcluirCredenciamentos;
      const result = await this.fetch(urlExcluirCredenciamentos, 'post', credenciamentos);
      return result;
    } catch (error) {
      console.error(error);
      return error;
    }
  }
  async validarCredenciamento (credenciamento, indInclusao) {
    try {
      const urlValidarCredenciamento = Configuracao.getConfiguracao().urlValidarCredenciamento + indInclusao;
      const result = await this.fetch(urlValidarCredenciamento, 'post', credenciamento);
      return result;
    } catch (error) {
      console.error(error);
      return error;
    }
  }
  async incluirCredenciamento (credenciamento) {
    try {
      const urlIncluirCredenciamento = Configuracao.getConfiguracao().urlIncluirCredenciamento;
      const result = await this.fetch(urlIncluirCredenciamento, 'put', credenciamento);
      return result;
    } catch (error) {
      console.error(error);
    }
  }
  async alterarCredenciamento (credenciamento) {
    try {
      const urlAlterarCredenciamento = Configuracao.getConfiguracao().urlAlterarCredenciamento;
      const result = await this.fetch(urlAlterarCredenciamento, 'put', credenciamento);
      return result;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarTelefones (codPrestador) {
    try {
      const urlTelefonesPrestador = Configuracao.getConfiguracao().urlTelefonesPrestador + codPrestador;
      const response = await this.fetch(urlTelefonesPrestador);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async incluirTelefone (telefone) {
    try {
      const urlIncluirTelefone = Configuracao.getConfiguracao().urlIncluirTelefone;
      const result = await this.fetch(urlIncluirTelefone, 'put', telefone);
      return result;
    } catch (error) {
      console.error(error);
    }
  }
  async alterarTelefone (telefone) {
    try {
      const urlAlterarTelefone = Configuracao.getConfiguracao().urlAlterarTelefone;
      const result = await this.fetch(urlAlterarTelefone, 'put', telefone);
      return result;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirTelefonesEmLote (telefones) {
    try {
      const urlExcluirTelefones = Configuracao.getConfiguracao().urlExcluirTelefones;
      const result = await this.fetch(urlExcluirTelefones, 'post', telefones);
      return result;
    } catch (error) {
      console.error(error);
      return error;
    }
  }
  async validarPrestador (prestador, indInclusao) {
    try {
      const urlValidarPrestador = Configuracao.getConfiguracao().urlValidarPrestador + indInclusao;
      const result = await this.fetch(urlValidarPrestador, 'post', prestador);
      return result;
    } catch (error) {
      console.error(error);
      return error;
    }
  }
}
export default PrestadorApi;
